import { Directive, Input, ElementRef, Renderer2 } from '@angular/core';
import { isEmpty } from 'lodash';
import { AuthenticationService } from 'app/services';

@Directive({
    selector: '[rbac]'
})
export class RoleBasedAccessControlDirective {
    private data: any;
    private currentUser: any;

    @Input('rbac')
    set _data(data: any) {
        this.data = !isEmpty(data) ? data : {};
        this.setConditions();
    }

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private _authenticationService: AuthenticationService
    ) {
        this.currentUser = this._authenticationService.currentUserValue;
    }

    private setConditions(): void {
        if (!this.currentUser || !this.data) return;

        const role = this.currentUser.user_role;

        if (this.data.hide_for && this.data.hide_for.includes(role)) {
            this.renderer.addClass(this.el.nativeElement, 'hidden');
            return; // no need to check disable if already hidden
        }

        // hide_if: extra condition, e.g. a record shared with the user's
        // agency (read-only). Re-evaluated whenever the input changes.
        if ('hide_if' in this.data) {
            if (this.data.hide_if) {
                this.renderer.addClass(this.el.nativeElement, 'hidden');
            } else {
                this.renderer.removeClass(this.el.nativeElement, 'hidden');
            }
        }
    }
}
